module.exports = __webpack_public_path__ + "img/sec5_6.a502bb4b.jpg";